export default __webpack_public_path__ + "static/media/mskbgImg.ceb64714.jpg";